import { gql } from '../../__generated__/gql'

export const SONGS_LIST_QUERY = gql(`
  query songsListQuery(
    $q: String
    $page: Int
    $perPage: Int
    $songKeys: [String!]
    $timeSignatures: [String!]
    $bpmRange: [Int!]
    $vibeIds: [VibeEnum!]
    $voiceIds: [Int!]
    $difficultyIds: [String!]
    $genreIds: [Int!]
    $themeIds: [Int!]
    $artistIds: [Int!]
    $albumIds: [Int!]
    $orderBy: SortSongsEnum
    $favorite: Boolean
  ) {
    songs(
      q: $q
      page: $page
      perPage: $perPage
      songKeys: $songKeys
      timeSignatures: $timeSignatures
      bpmRange: $bpmRange
      vibeIds: $vibeIds
      voiceIds: $voiceIds
      difficultyIds: $difficultyIds
      genreIds: $genreIds
      themeIds: $themeIds
      artistIds: $artistIds
      albumIds: $albumIds
      orderBy: $orderBy
      favorite: $favorite
    ) {
      ...songFields
    }
  }
`)
